<template>
  <v-container class="pa-0">
    <v-row dense>
      <v-col v-if="progressIsPinned" cols="12">
        <!--<ProgressTrack :track="pinnedProgressTrack" />-->
      </v-col>

      <v-col cols="12" class="pb-4 px-4">
        <Log />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
  import Log from '@/components/Log';
  import {mapGetters} from 'vuex';

  export default {
    name: 'Home',
    components: {Log},
    data() {
      return {
      };
    },
    computed: {
      ...mapGetters('progress', ['progressIsPinned', 'pinnedProgressTrack']),
      computedHeight() {
        if (this.progressIsPinned) {
          return '45vh';
        } else {
          return '80vh';
        }
      },
    },
  };
</script>
